import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InMemoryScrollingFeature, provideRouter, withInMemoryScrolling } from '@angular/router';
import { BASE_PATH as BASE_PATH_BE, RestUzivatelService } from '@generated/be';
import { BE_API_URL } from '@reza-ais-fe/reza-ais-fe-utils';
import { BASE_TITLE_TOKEN } from '@shared/modules/page-settings';
import { FORM_ERROR_PROVIDER, FormFieldUniqNames, UiFormsModule } from '@shared/ui/forms';
import {
  AdvancedConsoleProvider,
  AppCanActivate,
  AuthGuard,
  AuthService,
  Environment,
  ENVIRONMENT_JSON,
  ErrorApiInterceptor,
  JwtInterceptor,
  LoadingInterceptor,
  LOGGER_PROVIDERS,
  LogLevel,
  MIN_LOG_LEVEL,
  ProcessRequestInterceptor,
  RouteParamsService,
  StorageService,
  UIService,
} from '@shared/utils';
import { MessageService } from 'primeng/api';
import { appRoutes } from './app.routes';

const inMemoryScrollingFeature: InMemoryScrollingFeature = withInMemoryScrolling({
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
});

export function initApp(authService: AuthService): () => Promise<void> {
  return () => {
    authService.validateTokenAgeOnStartup(); // synchronní metoda
    return Promise.resolve(); // Angular ví, že může pokračovat
  };
}
export function createApplicationConfig(envJson: Environment): ApplicationConfig {
  const appConfig: ApplicationConfig = {
    providers: [
      importProvidersFrom([BrowserModule, BrowserAnimationsModule, UiFormsModule]),
      provideRouter(appRoutes, inMemoryScrollingFeature),
      provideHttpClient(withInterceptorsFromDi()),

      { provide: ENVIRONMENT_JSON, useValue: envJson },
      { provide: LOGGER_PROVIDERS, useClass: AdvancedConsoleProvider, multi: true },
      {
        provide: MIN_LOG_LEVEL,
        useValue: isDevMode() ? LogLevel.ERROR : LogLevel.NEVER,
      },
      {
        provide: FORM_ERROR_PROVIDER,
        useValue: {},
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: ErrorApiInterceptor,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: ProcessRequestInterceptor,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: JwtInterceptor,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: LoadingInterceptor,
        multi: true,
      },
      {
        provide: BASE_TITLE_TOKEN,
        useValue: 'REZA AIS',
      },

      /**
       * rest api endpoints
       */
      {
        provide: BASE_PATH_BE,
        useValue: BE_API_URL,
      },
      AuthService,
      RestUzivatelService,
      RouteParamsService,
      MessageService,
      FormFieldUniqNames,
      StorageService,

      AuthGuard,
      AppCanActivate,

      // ✅ APP_INITIALIZER – zde proběhne kontrola tokenu ještě před načtením routy
      {
        provide: APP_INITIALIZER,
        useFactory: initApp,
        deps: [AuthService, UIService], // závislosti jsou zajištěny
        multi: true,
      },
    ],
  };
  return appConfig;
}
